<template lang="pug">
  .answers-feed
    .answers-feed__search.main-block
      .ajax__line.courses__ajax.courses__ajax_s(v-if="gettingFeedTaskList")
      template(v-else)
        SelectGroup(
          v-model="choosen"
          :fields="selectData"
          placeholder="Выберите курс для проверки"
        )
        SelectCourse(
          v-model="taskInfo"
          :selectData="choosen"
          :fields="courseData"
          placeholder="Выберите раздел для проверки"
        )
        Select(
          v-model="statusInfo"
          :selectData="statusData"
          :disabled="!this.taskInfo"
          placeholder="Выберите статус"
        )

        InputDate.search.-answers-analytics__item(
          v-model="date"
          range
          @input="setDate"
          :showClear="showClearDate"
        )

        Search(
          v-if="checkPermission({key: 'userModuleAdmin', type: 'read'})"
          v-model="search"
          :taskInfo="taskInfo"
          :courseId="choosen"
        )

    SkeletonCard(v-if="gettingFeedTask || gettingSearchingFeedTask")
    PageScroll.answers-feed__content-list(
      :data="taskBlocks"
      :isLoading="gettingFeedTask || gettingSearchingFeedTask"
      v-else-if="taskBlocks.length > 0"
      @incrementPage="addFeedTasksCall"
    )
      template(v-for="(task, idx) in taskBlocks")
        Task(
          v-if="task" :key="idx"
          :propTask="task"
          :taskInfo="taskInfo"
          :tariffs="tariffs"
        )
      .ajax__line.courses__ajax.courses__ajax_s(v-if="addingFeedTask")
    TableEmpty(v-else style="top: 40%")

</template>

<script>
import _ from 'lodash';
import Task from './components/Task';
import SelectGroup from './components/Select/Select';
import SelectCourse from './components/Select/SelectCourse';
import SkeletonCard from './components/Skeleton/SkeletonCard';
import Search from './components/Search';
import { mapState, mapActions } from 'vuex';
import replaceMultipleRouteQuery from '@/functions/replaceMultipleRouteQuery';

export default {
  components: { Task, SkeletonCard, Search, SelectGroup, SelectCourse },
  data() {
    return {
      taskInfo: '',
      choosen: '',
      taskBlocks: [],
      search: '',
      statusInfo: null,
      date: [],
      initialLoading: false
    };
  },
  computed: {
    ...mapState('answersValidatingFeed', {
      feedTaskList: s => s.data.feedTaskList,
      selectData: s => s.data.selectData,
      courseData: s => s.data.courseData,
      storeTaskBlocks: s => s.data.taskBlocks,
      tariffs: s => s.data.tariffs,
      gettingFeedTask: s => s.meta.gettingFeedTask,
      gettingFeedTaskList: s => s.meta.gettingFeedTaskList,
      addingFeedTask: s => s.meta.addingFeedTask,
      gettingSearchingFeedTask: s => s.meta.gettingSearchingFeedTask
    }),
    ...mapState('auth', {
      $permissions: s => s.data.user.permissions.taskAnswerCheckAdmin,
      $otherPermissions: s => s.data.user.permissions,
      isAdmin: s => s.data.user.permissions.isAdmin
    }),
    getTaskList() {
      const nullData = {
        clearData: { name: 'Без групп' }
      };
      if (this.feedTaskList) {
        return [nullData, ...this.feedTaskList];
      }

      return [];
    },
    statusData() {
      return [
        {
          text: 'Все статусы',
          value: undefined
        },
        {
          text: 'Статус проверено',
          value: true
        },
        {
          text: 'Статус не проверено',
          value: false
        }
      ];
    },
    showClearDate() {
      const flag = !!(this.date && this.date.length);
      return flag;
    }
  },
  watch: {
    storeTaskBlocks() {
      this.taskBlocks = _.cloneDeep(this.storeTaskBlocks);
    },
    choosen() {
      this.getTaskListData(this.choosen);
      if (this.$route.query.name) {
        this.searchFeedTaskEmail({ courseId: this.choosen });
      }
    },
    taskInfo() {
      this.taskInfo && this.getFeedTasks(this.taskInfo);
    },
    statusInfo() {
      replaceMultipleRouteQuery(
        Object.entries({
          ...this.$route.query,
          isHasValidator: this.statusInfo
        }).map(el => ({
          value: el[1],
          name: el[0],
          method: 'replace'
        }))
      );

      // this.taskInfo && this.getFeedTasks(this.taskInfo)
    },
    '$route.query'() {
      if (this.choosen && this.taskInfo) {
        this.getFeedTasks(this.taskInfo);
      }
    }
  },
  mounted() {
    this.date = [this.$route.query.dateStart, this.$route.query.dateEnd];
    this.getTaskListCourse();
    const userBoolean = this.$route.query.userId && this.$route.query.name;
    const boolean = this.$route.query.taskBlock && this.$route.query.courseId;
    if (!userBoolean) {
      return;
    }

    boolean ? this.setDataToLoad() : this.searchFeedTaskEmail();
  },
  destroyed() {
    this.$store.dispatch('answersValidatingFeed/setData', {
      path: 'lessonId',
      value: ''
    });
    this.clearFeedTaskBlocks();
    replaceMultipleRouteQuery([
      {
        value: '',
        name: 'userId',
        method: 'replace'
      },
      {
        value: '',
        name: 'name',
        method: 'replace'
      }
    ]);
  },
  methods: {
    ...mapActions('answersValidatingFeed', [
      'getTaskListCourse',
      'getTaskListData',
      'clearFeedTaskBlocks',
      'searchFeedTaskEmail',
      'setData'
    ]),
    getFeedTasks(data) {
      if (this.initialLoading) {
        return;
      }
      this.$store.dispatch('answersValidatingFeed/getFeedTasks', {
        isHasValidator: this.statusInfo,
        ...data
      });
    },
    addFeedTasksCall(page) {
      if (!this.$route.query.userId) {
        this.getFeedTasks({ page, ...this.taskInfo });
      }
    },
    async setDataToLoad() {
      this.initialLoading = true;

      this.choosen = this.$route.query.courseId;
      this.taskInfo = JSON.parse(this.$route.query.taskBlock);
      this.statusInfo = this.$route.query.isHasValidator;
      this.date = [this.$route.query.dateStart, this.$route.query.dateEnd];

      this.setData({ path: 'lessonId', value: this.$route.query.lessonId });
      await this.$store.dispatch('answersValidatingFeed/getFeedTasks', {
        page: this.page || 1,
        ...this.taskInfo
      });
      this.clearQuery();

      this.initialLoading = false;
    },
    clearQuery() {
      replaceMultipleRouteQuery([
        {
          value: undefined,
          name: 'courseId',
          method: 'replace'
        },
        {
          value: undefined,
          name: 'taskBlock',
          method: 'replace'
        },
        {
          value: this.$route.query.name,
          name: 'name',
          method: 'replace'
        },
        {
          value: this.$route.query.userId,
          name: 'userId',
          method: 'replace'
        }
      ]);
    },
    setDate(date) {
      if (!date) {
        this.clearDate();
      } else if (date.length === 2) {
        replaceMultipleRouteQuery(
          Object.entries({
            ...this.$route.query,
            dateStart: date[0],
            dateEnd: date[1]
          }).map(el => ({
            value: el[1],
            name: el[0],
            method: 'replace'
          }))
        );
      }
    },
    clearDate() {
      replaceMultipleRouteQuery(
        Object.entries({
          ...this.$route.query,
          dateStart: undefined,
          dateEnd: undefined
        }).map(el => ({
          value: el[1],
          name: el[0],
          method: 'replace'
        }))
      );
    }
  }
};
</script>
